import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import moment from "moment";
import dateTimeHelper from "./js/dateTimeHelper";
import Icon from "./icon.vue";
import L from "leaflet";
import * as proj4x from "proj4";
import store from "./store";
import "./registerServiceWorker";
import { i18n } from "./i18n.js";

window["L"] = L;
// Moment
window["moment"] = moment;
moment.locale("da");

if (process.env.NODE_ENV === "development") {
  // Dev values

  /**
   * This APPID is the same as prod since the
   * local database is a dump from production
   */
  window["APPID"] = "5c98b8614680d182bc5805d8";
  //window['APPID'] = '5b3b1e45e55fbc4794180c21'

  window["host"] = "http://localhost:8081";
  window["APIhost"] = "https://localhost:44384";
  window["env"] = "dev";
} else {
  // Kortinfo Prod values
  window["APPID"] = "5c98b8614680d182bc5805d8";

  window["host"] = "";
  window["APIhost"] =
    window.location.protocol + "//" + window.location.host + "/admin";
  window["env"] = "prod";
}

window["APPVERSION"] = "2.0.0";
window["assetsFolder"] = "static";

Vue.prototype._APIhost = window.APIhost;

Vue.component("icon", Icon);

require("leaflet/dist/leaflet.css");
require("./js/map/leaflet-pointer/L.Control.MapCenterCoord.min.js");
window.proj4 = proj4x.default;
require("./js/map/proj4leaflet");

Vue.filter("formatDate", function(date) {
  return dateTimeHelper.formatDate(date);
});

Vue.filter("formatDateWithTime", function(date) {
  return dateTimeHelper.formatDateWithTime(date);
});

Vue.filter("formatNumber", function(bytes) {
  let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) {
    return "0 Byte";
  }
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
});

Vue.filter("toUpperCase", function(string) {
  if (string) {
    return string.toUpperCase();
  } else {
    return string;
  }
});

function getUrlParameter(name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

// console.log("window.location: ", window.location.href);
localStorage.setItem("formId", getUrlParameter("formId"));
localStorage.setItem("apiKey", getUrlParameter("apiKey"));
localStorage.setItem("revisionNo", getUrlParameter("revisionNo"));

// console.log("getUrlParameter", getUrlParameter("formId"));

// Handling global errors
window.onerror = function(msg, url, lineNo, columnNo, error) {
  // eslint-disable-next-line
  var errMsg = [
    "Message: " + msg,
    "URL: " + url,
    "Line: " + lineNo,
    "Column: " + columnNo,
    "Error object: " + JSON.stringify(error)
  ].join(";");

  // Check if errorlog template already exists
  if (!localStorage["errorLogTemplate"]) {
    // Get template
    axios
      .get(window["APIhost"] + "/api/v2/clienterrorlog/new", {
        params: {
          apiKey: localStorage.getItem("apiKey"),
          formId: localStorage.getItem("formId")
        }
      })
      .then(log => {
        // Add errorlog template to localstorage
        localStorage.setItem("errorLogTemplate", log);
      });
  }
};

Vue.config.productionTip = false;

export const EventBus = new Vue();

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

//console.log("app: ", app);
